// extracted by mini-css-extract-plugin
module.exports = {"container":"Services-module--container--16GB4","price":"Services-module--price--1sv2w","button":"Services-module--button--2vBfX"};